import { useMutation } from "@apollo/client";
import { DSPalette } from "@clickbank-ui/seller-design-system";
import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { Trans } from "react-i18next";

import { ApolloClient, CANCEL_PENDING_ORDER } from "../../../Api";
import { AppContext } from "../../../context/AppContext";

const { palette } = DSPalette;

const getStateStyles = state => {
	switch (state) {
		case "TOO_MANY_ATTEMPTS":
		case "PRICE_TOO_LOW":
		case "CANCELED_BY_USER":
		case "ERROR":
			return {
				bar: {
					backgroundColor: palette.error.light
				},
				text: {
					label: <Trans i18nKey="OrderDetails.pending.Canceled">Order Canceled</Trans>,
					color: palette.error.dark
				}
			};
		case "PENDING_RETRY":
		case "RETRYING":
		case "SUCCESS":
		default:
			return {
				bar: {
					border: "1px solid #C8C7D1"
				},
				text: {
					label: <Trans i18nKey="OrderDetails.pending.Pending">Order Pending</Trans>
				}
			};
	}
};

export const PendingOrderState = ({ receipt, pendingOrderState }) => {
	const { setAlertText, showAlert, setAlert, setActionSuccessful, refetchOrderByReceiptNo } =
		useContext(AppContext);

	const [cancelOrder, { loading }] = useMutation(CANCEL_PENDING_ORDER, {
		client: ApolloClient,
		onError: () => {
			setAlertText(
				<Trans i18nKey="Common.error.unknown">
					An unknown error has occurred. Please contact customer support directly.
				</Trans>
			);
			setAlert(true);
			setActionSuccessful(false);
		},
		onCompleted: () => {
			refetchOrderByReceiptNo(receipt);
			!showAlert && setAlert(true);
			setAlertText(
				<Trans i18nKey="OrderSummary.orderPendingCancelled">
					Your order was canceled successfully
				</Trans>
			);
			setActionSuccessful(true);
		}
	});

	if (!pendingOrderState) {
		return null;
	}

	const {
		text: { label, ...text },
		bar
	} = getStateStyles(pendingOrderState);

	return (
		<>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="center"
				mt={{ xs: "24px" }}
				sx={{
					height: 48,
					padding: "0 1rem",
					borderRadius: "4px",
					...bar
				}}
			>
				<Typography
					sx={{
						fontSize: "17px",
						fontWeight: "600",
						...text
					}}
				>
					{label}
				</Typography>
			</Box>
			{(pendingOrderState === "PENDING_RETRY" || pendingOrderState === "RETRYING") && (
				<LoadingButton
					fullWidth
					variant="outlined"
					color="warning"
					onClick={() => cancelOrder({ variables: { receipt } })}
					disabled={loading}
					loading={loading}
				>
					<Trans i18nKey="OrderDetails.cancelOrder">Cancel Order</Trans>
				</LoadingButton>
			)}
		</>
	);
};

export default PendingOrderState;
